import { render, staticRenderFns } from "./AddSQL.vue?vue&type=template&id=5bb5d59f&scoped=true&"
import script from "./AddSQL.vue?vue&type=script&lang=js&"
export * from "./AddSQL.vue?vue&type=script&lang=js&"
import style0 from "./AddSQL.vue?vue&type=style&index=0&id=5bb5d59f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb5d59f",
  null
  
)

export default component.exports